export const consultPlanesAdmin = state => state.planesAdminState;
export const getPlanAdmin = state => state.planAdminState;
